import { Skeleton } from "@/components/ui/skeleton";

export const FaqSkeleton = () => {
  return (
    <section
      id="faq"
      className="container grid grid-cols-1 gap-x-12 gap-y-8 py-12 lg:grid-cols-[45%_55%] lg:py-32"
    >
      {/* Left column - heading */}
      <div className="flex flex-col gap-4">
        <Skeleton className="h-12 w-3/4 rounded-md lg:h-20" />
        <Skeleton className="h-6 w-full rounded-md lg:h-12" />
      </div>

      {/* Right column - accordion items */}
      <div className="space-y-2">
        {[...Array(8)].map((_, i) => (
          <div key={i}>
            {/* Question */}
            <Skeleton className="mb-3 h-8 w-full rounded-md lg:h-12" />
          </div>
        ))}
      </div>
    </section>
  );
};
